import styled, { css } from 'styled-components';
import { animated } from '@react-spring/web';

import Link from 'Elements/Link';
import Icon from 'Elements/Icon';

export const Container = styled.div`
    ${({ theme }) => css`
        display: flex;
        flex-direction: column;
        position: relative;
        border-radius: 0.5rem;
        border: 0.0625rem solid ${theme.colors.secondary.tints[1].hex};

        @media ${theme.breakpoints.mediumSmall.media} {
            flex-direction: row;
            border-radius: 0.5rem 0.5rem 0 0;
        }

        @media ${theme.breakpoints.large.media} {
            border-radius: 0.5rem;
        }
    `}
`;

export const ImageLink = styled(Link)`
    ${({ theme }) => css`
        display: block;
        width: 100%;
        height: 8.75rem;
        position: relative;
        overflow: hidden;
        border-radius: 0.5rem 0.5rem 0 0;
        flex: 0 0 auto;

        @media ${theme.breakpoints.mediumSmall.media} {
            width: 14rem;
            height: auto;
            border-radius: 0.5rem 0 0 0;
        }

        @media ${theme.breakpoints.large.media} {
            border-radius: 0.5rem 0 0 0.5rem;
        }
    `}
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    color: ${({ theme }) => theme.colors.tertiary.hex};
`;

export const Info = styled.div`
    ${({ theme }) => css`
        padding: 1rem 0.75rem;

        @media ${theme.breakpoints.medium.media} {
            padding: 1rem 1.5rem;
        }
    `}
`;

export const ImageWrapperDefault = styled(animated.div)`
    ${({ theme }) => css`
        display: none;

        @media ${theme.breakpoints.mediumSmall.media} {
            display: block;
            height: 100%;
            width: 100%;
        }
    `}
`;

export const ImageWrapperMobile = styled(animated.div)`
    ${({ theme }) => css`
        height: 100%;
        width: 100%;

        @media ${theme.breakpoints.mediumSmall.media} {
            display: none;
        }
    `}
`;

export const Heading = styled.h2`
    margin: 0;
    font-size: 1.375rem;

    @media ${({ theme }) => theme.breakpoints.large.media} {
        margin-bottom: 0.3rem;
        font-size: 1.75rem;
    }
`;

export const StyledLink = styled(Link)`
    all: inherit;
    cursor: pointer;
`;

export const Location = styled.div`
    display: flex;
    justify-content: flex-start;
    flex-direction: column;

    @media ${({ theme }) => theme.breakpoints.large.media} {
        flex-direction: row;
        font-size: 1.5rem;
    }
`;

export const LocationItem = styled.div`
    display: flex;
    align-items: center;
    margin-right: 2rem;
    margin-bottom: 0.5rem;

    @media ${({ theme }) => theme.breakpoints.large.media} {
        margin-bottom: 0;
    }
`;

export const StyledIconLocation = styled(Icon)`
    color: ${({ theme }) => theme.colors.secondary.tints[3].hex};
    height: 1.5rem;
    width: 1.5rem;
`;

export const LocationText = styled.span`
    ${({ theme }) => css`
        margin: 0 0 0 0.5rem;
        font-size: 1rem;
        font-weight: 300;
        line-height: 1.1;
        color: ${theme.colors.secondary.tints[3].hex};
    `}
`;

export const Text = styled.p`
    font-size: 1.125rem;
`;

export const FeatureList = styled.ul`
    column-count: 2;
    padding: 0;
    margin-bottom: 0;

    @media ${({ theme }) => theme.breakpoints.medium.media} {
        display: flex;
        flex-wrap: wrap;
    }
`;

export const FeatureItem = styled.li`
    ${({ theme }) => css`
        font-family: ${theme.fonts.secondary};
        display: inline-flex;
        align-items: center;
        font-size: 1rem;
        font-weight: 400;
        margin-top: 0.3rem;

        &:not(:last-child) {
            margin-right: 1rem;
        }
    `}
`;

export const StyledIcon = styled(Icon)`
    ${({ theme }) => css`
        color: ${theme.colors.tertiary.hex};
        height: 1.5rem;
        min-height: 1.5rem;
        width: 1.5rem;
        min-width: 1.5rem;
        margin-right: 0.5rem;
    `}
`;

export const FooterInfo = styled.div`
    ${({ theme }) => css`
        background-color: ${theme.colors.secondary.tints[1].hex};
        padding: 1rem 2rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border-bottom-left-radius: 0.5rem;
        border-bottom-right-radius: 0.5rem;

        @media ${theme.breakpoints.medium.media} {
            display: none;
        }

        @media ${theme.breakpoints.large.media} {
            display: inherit;
            flex-direction: row;
            justify-content: space-between;
            border-bottom-left-radius: 0;
        }
    `}
`;

export const FooterInfoTablet = styled.div`
    ${({ theme }) => css`
        display: none;

        @media ${theme.breakpoints.medium.media} {
            background-color: ${theme.colors.secondary.tints[1].hex};
            padding: 1rem 2rem;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            border-bottom-left-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
            margin-top: -0.05rem;
            position: relative;
        }

        @media ${theme.breakpoints.large.media} {
            display: none;
        }
    `}
`;

export const PriceContent = styled.div`
    display: flex;
    align-items: center;
`;

export const PriceWrapper = styled.div`
    ${({ theme }) => css`
        display: flex;
        line-height: 1.2;

        @media ${theme.breakpoints.large.media} {
            flex-direction: column;
        }
    `}
`;

export const Price = styled.span`
    font-weight: bold;
    margin-left: 0.2rem;

    @media ${({ theme }) => theme.breakpoints.large.media} {
        margin-left: 0;
    }
`;

export const FooterIcon = styled(Icon)`
    ${({ theme }) => css`
        color: var(--infoBar-txt-colour, ${theme.colors.secondaryContrast.hex});
        height: 2rem;
        width: 2rem;
        margin-right: 1rem;
    `}
`;
